export const inventorySourceTypes = {
  none: 'None',
  native: 'Native',
  store: 'Store',
  integration: 'Integrations',
};

export const inventoryWarehouseTypes = {
  individual: 'Individual',
  aggregate: 'Aggregate',
};

export const noneInventorySource = {
  inventorySourceType: inventorySourceTypes.none,
  inventorySourceId: null,
  inventorySourceExternalId: null,
};
